<script>
// 邀请提示气泡：黄色描边、向下箭头指向 EARN CASH 分享区，无黑色遮罩，5 秒后自动消失
export default {
  mounted () {
    this._tipTimer = setTimeout(() => {
      this.$store.commit('shareTip', false)
    }, 5000)
  },
  beforeUnmount () {
    if (this._tipTimer) {
      clearTimeout(this._tipTimer)
      this._tipTimer = null
    }
  },
  methods: {
    dismiss () {
      this.$store.commit('shareTip', false)
    }
  }
}
</script>

<template>
  <div class="invite-tip" @click="dismiss">
    <span>{{ this.$store.state.shareTipEn ? this.$store.state.shareTipEn : 'Click the button to invite your friends install' }}</span>
  </div>
</template>

<style scoped>
/* 邀请气泡：整块用切图 bg_invite_popup.png（370x114，含黄边和向下的尾巴）
   盒子按图片比例(3.246)设尺寸避免变形；下方留白给内置尾巴，文字居中在矩形区 */
.invite-tip {
  width: 46rem;
  height: 14.2rem;
  box-sizing: border-box;
  background: url("@/assets/bg_invite_popup.png") center / 100% 100% no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 让文字居中在切图的矩形区(垂直中心≈41.7%)，底部留白给向下尾巴 */
  padding: 1rem 5rem 3.36rem 5rem;
  color: #FFFFFF;
  font-size: 2.4rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.25;
}
</style>
